export const socialMediaLinksKeys = {
  get: () => ['SOCIAL_MEDIA_LINKS'],
};
